import React from 'react';
import vars from '@variables';
import {
  Wrapper,
  DropdownWrapper,
  DropdownLink,
  DropdownExternalLink,
  StyledButton,
} from './navbar-language-button.styles';
import { GTM_ID } from '../../../../common/constants/gtmIds';
import { GlobeIconAtom } from '@atoms/icon-atoms/nav-icon-atoms';
import { NavbarLanguageButtonProps } from './navabar-language-button.types';

export const NavbarLanguageButton: React.FC<NavbarLanguageButtonProps> = ({
  locale,
  languages,
  navbarLocaleLinks = [],
  handleClick,
  isExpanded,
  hasTransparentBackground,
  textColor,
  selectedTab,
}) => {
  const setLanguageFromLocale = () => {
    if (locale === 'pt') return 'Pt';
    if (locale === 'fr') return 'Fr';
    if (locale === 'es') return 'Es';
    return 'En';
  };

  const languageLinks = languages.map(language => {
    const matchLocale = navbarLocaleLinks.find(
      link => link.code.slice(0, 2) === language.abbreviation
    );

    if (matchLocale) {
      return {
        ...language,
        link: {
          ...language.link,
          path: matchLocale.url,
        },
      };
    }

    return language;
  });

  const setTextColor = () => {
    if (selectedTab || isExpanded) {
      return vars.coreDarkGrey;
    }
    return textColor;
  };

  const setHideBorders = () => {
    if (selectedTab || isExpanded) {
      return false;
    }
    return hasTransparentBackground;
  };

  return (
    <Wrapper>
      <StyledButton
        onClick={() => handleClick()}
        data-gtm-id={GTM_ID.MAIN_NAV_LINK_LANG}
        isExpanded={isExpanded}
        hideBorders={setHideBorders()}
        textColor={setTextColor()}
      >
        <GlobeIconAtom
          width="28"
          height="28"
          stroke={setTextColor()}
          fill={setTextColor()}
        />
        {setLanguageFromLocale()}
      </StyledButton>
      {isExpanded && (
        <DropdownWrapper>
          {languageLinks.map(language => {
            if (language.link.isExternal) {
              return (
                <DropdownExternalLink
                  key={language.abbreviation}
                  href={language.link.path}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-gtm-id={`${GTM_ID.FLYOVER_LINK_COLUMN}1`}
                >
                  {language.title}
                </DropdownExternalLink>
              );
            }
            return (
              <DropdownLink
                key={language.abbreviation}
                to={language.link.path}
                data-gtm-id={`${GTM_ID.FLYOVER_LINK_COLUMN}1`}
              >
                {language.title}
              </DropdownLink>
            );
          })}
        </DropdownWrapper>
      )}
    </Wrapper>
  );
};
